import { trackAssessmentEvent } from '../../lib/analytics/events'
import { loadBrsrState } from '../../lib/brsr/session'
import { mountBrsrResults } from './results'
import { mountBrsrWizard } from './wizard'

function boot(): void {
  const root = document.getElementById('brsr-root')
  if (!root) return
  const page = root.dataset.page || 'landing'
  const state = loadBrsrState()

  if (page === 'landing') {
    trackAssessmentEvent('assessment_view', { tool: 'india-brsr-readiness' })
    return
  }
  if (page === 'start') {
    mountBrsrWizard(root, state)
    return
  }
  if (page === 'results') {
    mountBrsrResults(root, state)
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
